var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1439 11.7322L8.71 13.78M14.3084 11.5962L12.3964 14.3267M5.97949 11.8681L3.11161 15.9639M6.79799 16.5105L6.32001 17.1932M2.6483 10.3374L1.21436 12.3853M5.63019 11.1083C3.41152 10.4743 1.80096 8.57653 1.80096 6.33398C1.80096 3.57256 4.24304 1.33398 7.2555 1.33398C9.27445 1.33398 11.0372 2.33948 11.9803 3.83398H13.051C15.122 3.83398 16.801 5.51292 16.801 7.58398C16.801 9.65505 15.122 11.334 13.051 11.334H6.91459C6.46341 11.334 6.03085 11.2543 5.63019 11.1083Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyRain);
export default __webpack_public_path__ + "static/media/grey-rain.98e90f9061c698f291059cd43e72e5db.svg";
export { ForwardRef as ReactComponent };